export const DEFAULT_ERROR_MESSAGE =
  '[fetchBestPlaceAnalyticsPaymentUrl]: Ошибка получения url для оплаты аналитического отчета best place';

export const DOMAIN_TEXT = 'shared/services/bestPlaceAnalytics/fetchBestPlaceAnalyticsPaymentUrl#fetchGetPaymentUrl()';
